import { useContext, useDebugValue } from "react";
import AuthContext from "../context/AuthProvider";

export const useValidateSubscriptionState = () => {
    const { auth } = useContext(AuthContext);
    return auth?.account?.Role === 'SUPER_ADMIN' || ["ACTIVE", "TRIALING"].includes(auth?.account?.VideoBoostClient?.subscriptionState);
};

export const useValidateBillingProfileExistence = () => {
    const { auth } = useContext(AuthContext);
    return auth?.account?.Role === 'SUPER_ADMIN' || auth?.account?.VideoBoostClient?.billingProfileId;
};

const useGetFeature = (featureId) => {
    const { auth } = useContext(AuthContext);
    const features = auth?.account?.VideoBoostClient?.features;
    if (features) {
        return features.find(c => c.featureId === featureId);
    }
    return null;
}

export const useGetFeatureCreateNewEvent = () => {
    return useGetFeature(1);
};

export const useGetFeatureCreateNewGallery = () => {
    return useGetFeature(2);
};

const useAuth = () => {
    const { auth } = useContext(AuthContext);
    useDebugValue(auth, auth => auth?.user ? "Logged In" : "Logged Out")
    return useContext(AuthContext);
}

export default useAuth;